module.exports = __webpack_public_path__ + "img/countries.b950db2e.png";